export default function tabsOnHoverUI () {
	tabsOnHoverInit('.js-tabs-on-hover');
}

const tabsOnHoverInit = (selector) => {
	const $tabs = $(selector);

	$tabs.each(function() {
		const $tabsItem = $(this);

		const $tabsNavItem = $tabsItem.find('.js-tabs-on-hover__nav a');

		$tabsNavItem.on('click', function(event) {
			event.preventDefault();

			$(this).addClass('active');
			$(this).closest('li').siblings().find('a').removeClass('active');

			const target = $(this).attr('href');
			$(`[data-tab-on-hover='${target}']`).addClass('active').siblings().removeClass('active');
		});
	});
}
